var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-occ-health.c8575d86.png","uri@2x": __webpack_public_path__ + "icon-occ-health.465150b2.png","uri@3x": __webpack_public_path__ + "icon-occ-health.36a99b14.png",
    width: 15,
    height: 18
});